import {useEffect,useState} from 'react';
import {useAppSelector} from '../hooks';
import {isSvipMember} from '../util/svipMembership';
export function useSvip(){
 const svip=useAppSelector(s=>s.character.svip),svipExpiresAt=useAppSelector(s=>s.character.svipExpiresAt),[now,setNow]=useState(Date.now());
 useEffect(()=>{setNow(Date.now());if(!svip||!svipExpiresAt)return;const timer=window.setInterval(()=>setNow(Date.now()),1000);return()=>window.clearInterval(timer);},[svip,svipExpiresAt]);
 return isSvipMember({svip,svipExpiresAt},now);
}
